import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './shared/store'
import './assets/scss/global.scss'
import './index.css'
import { createPinia } from "pinia";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import BaseCard from './components/Base/BaseCard.vue'
import BaseBtn from './components/Base/BaseBtn.vue'
import { useLoaderStore } from './shared/store/loader';
import { useDialogStore } from './shared/store/dialog'

// perfectscrollbar plugins 
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import VueApexCharts from "vue3-apexcharts";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// globally call 

// app.component('BaseBtn', BaseBtn)


createApp(App)
    .component('BaseCard', BaseCard)
    .component('BaseBtn', BaseBtn)
    .use(pinia)
    .use(PerfectScrollbar)
    .use(VueApexCharts)
    .use(store)
    .use(router)
    .mount('#app')
